import React, { Component } from "react";
import { connect } from "react-redux";
import * as actionCreator from "../../../../action/index.js";
import Accordion from "react-bootstrap/Accordion";
import EditPriceItem from "../../../EditPriceItem/EditPriceItem";
import { Select } from "@rmwc/select";
import FullyOpenImg from "../../../../assets/images/thumbimages/walls/leftwall/left-open.png";
import FullyEnclosedImg from "../../../../assets/images/thumbimages/walls/leftwall/left-fully-enclosed.png";
import AddStorageImg from "../../../../assets/images/thumbimages/walls/leftwall/left-add-storage.png";
import CurrencyFormat from "react-currency-format";
import { Checkbox } from '@rmwc/checkbox';
import { Radio } from '@rmwc/radio';
import SideJTrimPrice from '../SideJTrimPrice.js';
import EndJTrimPrice from '../EndJTrimPrice.js';
import { params, const_var } from '../../../../redux/reducers/reducer.js';
import Dropdown from 'react-bootstrap/Dropdown';
import { calcNumOfWalls } from "../../../../helpers/building_pricing/wall_pricing/wallPricing.helper.js";
const DropDefaultToggle = React.forwardRef(({ children, onClick }, ref) => (
  <a
    href=""
    className="drop-default-toggle"
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </a>
));

class BackLeantoWalls extends Component {

  getBackLeanWallPrice = (walltype, position) => {
    const { side, end, gable_end, panel } = this.props.const_var.leanGetDataBack !== undefined && this.props.const_var.leanGetDataBack;
    let wallPrice = 0;
    if (this.props.params.p_v_w) {
      if (position == "end") {
        switch (walltype) {
          case "Half_Close":
            wallPrice = end !== undefined && end[0].half_vertical_ends_cost + end[0].half_end_close_cost;
            break;
          case "One_Fourth_Close":
            wallPrice = end !== undefined && end[0].one_fourth_vertical_ends_cost + end[0].one_fourth_end_close_cost;
            break;
          case "Three_Fourth_Close":
            wallPrice = end !== undefined && end[0].three_fourth_vertical_ends_cost + end[0].three_fourth_end_close_cost;
            break;
          case "Close":
            wallPrice = end !== undefined && end[0].vertical_ends_cost + end[0].end_close_cost;
            break;
          case "Extended Gable":
            wallPrice = gable_end !== undefined && (gable_end[0].vertical_extended) + (gable_end[0].extended);
            break;
          case "Gable":
            wallPrice = gable_end !== undefined && gable_end[0].certified !== 0 ? (gable_end[0].vertical_certified) + gable_end[0].certified : (gable_end[0].vertical) + gable_end[0].uncertified;
            break;
          case "Open":
            wallPrice = 0;
            break;
          default:
            wallPrice = 0;
        }

      } else {
        switch (walltype) {
          case "Half_Close":
            wallPrice = side !== undefined && side[0].half_vertical_side_cost + side[0].half_side_close_cost;
            break;
          case "One_Fourth_Close":
            wallPrice = side !== undefined && side[0].one_fourth_vertical_side_cost + side[0].one_fourth_side_close_cost;
            break;
          case "Three_Fourth_Close":
            wallPrice = side !== undefined && side[0].three_fourth_vertical_side_cost + side[0].three_fourth_side_close_cost;
            break;
          case "Close":
            wallPrice = side !== undefined && side[0].vertical_side_cost + side[0].side_close_cost;
            break;
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
            wallPrice = panel !== undefined && (panel[0].vertical_panel_cost * walltype);
            break;
          default:
            wallPrice = 0;
        }
      }

    }
    else {
      if (position == "end") {
        switch (walltype) {
          case "Half_Close":
            wallPrice = end !== undefined && end[0].half_end_close_cost;
            break;
          case "One_Fourth_Close":
            wallPrice = end !== undefined && end[0].one_fourth_end_close_cost;
            break;
          case "Three_Fourth_Close":
            wallPrice = end !== undefined && end[0].three_fourth_end_close_cost;
            break;
          case "Close":
            wallPrice = end !== undefined && end[0].end_close_cost;
            break;
          case "Extended Gable":
            wallPrice = gable_end !== undefined && (gable_end[0].extended);
            break;
          case "Gable":
            if (gable_end !== undefined && gable_end.length > 0 && gable_end[0].certified !== undefined) {
              wallPrice = gable_end[0].certified == 0 ? gable_end[0].uncertified : gable_end[0].certified;
            }
            break;
          case "Open":
            wallPrice = 0;
            break;
          default:
            wallPrice = 0;
        }

      } else {
        switch (walltype) {
          case "Half_Close":
            wallPrice = side !== undefined && side[0].half_side_close_cost;
            break;
          case "One_Fourth_Close":
            wallPrice = side !== undefined && side[0].one_fourth_side_close_cost;
            break;
          case "Three_Fourth_Close":
            wallPrice = side !== undefined && side[0].three_fourth_side_close_cost;
            break;
          case "Close":
            wallPrice = side !== undefined && side[0].side_close_cost;
            break;
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
            wallPrice = panel !== undefined && (panel[0].cost * walltype);
            break;
          default:
            wallPrice = 0;
        }
      }

    }

    return wallPrice % 1 != 0 ? wallPrice.toFixed(2) : wallPrice;
  };
  setName=(selname, selArray)=>{
    let name = Object.entries(selArray).find(([key,val])=> val == selname)
    if(name !=undefined){
      return name[0]
    }
  }

  storageLength(e){
    if(this.props.const_var.is_loader == false){
      this.props.toggleAddUtilityCheckboxChangeForBack();
      this.props.getPricingDataForLeanto(e.target.value, 'addBackLean', '', false)
    }
  }

  render() {
    const {toggleDropdown} = this.props;
    let backLeanData = undefined;
    let backLeanIndex = undefined;
    let totalBackWallPrice = 0;
    const cb_a_p_d_a = JSON.parse(JSON.stringify(this.props.const_var.holdPricingResponse));

    if (this.props.const_var.post_data.building !== undefined && this.props.const_var.post_data.building.leanto.length > 0) {
      let mainData = this.props.const_var.post_data.building.leanto.filter(data => data.leanto_type == "4");
      if (mainData.length > 0) {
        backLeanData = mainData[0];
        backLeanIndex = this.props.const_var.post_data.building.leanto.findIndex(data => data.leanto_type == "4");
      } else {
        backLeanData = undefined;
        backLeanIndex = undefined;
      }

      totalBackWallPrice = backLeanData !== undefined ? (backLeanData.back_wall_price + backLeanData.front_wall_price + backLeanData.side_wall_price) : 0;
    }


    const { side, end } = this.props.const_var.leanGetDataBack !== undefined && this.props.const_var.leanGetDataBack;
    let totalClosedWallPrice = 0;

    if (this.props.params.p_v_w ) {
      totalClosedWallPrice = (end !== undefined && side !== undefined) ? (2 * (end[0]?.vertical_ends_cost + end[0]?.end_close_cost) + side[0]?.vertical_side_cost + side[0]?.side_close_cost) : 0;
    } else {
      totalClosedWallPrice = (end !== undefined && side !== undefined) ? ((2 * end[0]?.end_close_cost) + side[0]?.side_close_cost) : 0;
    }
    let isJtrimSide = false;
    let isJtrim = false;
    let chkEndJtrim = false;
    let chkSideJtrim = false;
    let EndJtrim_checkedDefault = false;
    let SideJtrim_checkedDefault = false;
    let chkSideJtrimNew = false;
    let checkSideWall = false;

    let totalSideWall = calcNumOfWalls('side','1')
    let totalEndWall = calcNumOfWalls('end','1')

    if ((cb_a_p_d_a.jtrim) && cb_a_p_d_a.jtrim.length > 0) {
      // chkEndJtrim = (cb_a_p_d_a.jtrim.filter(data=>data.type=="end")).length>0?true:false;
      // chkSideJtrim = (cb_a_p_d_a.jtrim.filter(data=>data.type=="side")).length>0?true:false;
      chkEndJtrim = (cb_a_p_d_a.jtrim.filter(data => data.type == "end"));
      if (chkEndJtrim.length > 0) {
        if (chkEndJtrim[0].is_jtrim != undefined && chkEndJtrim[0].is_jtrim === "included") {
          EndJtrim_checkedDefault = true;
        }
        chkEndJtrim = true;
      }
      chkSideJtrimNew = (cb_a_p_d_a.jtrim.filter(data => data.type == "side"));
      //chkEndJtrim = (cb_a_p_d_a.jtrim.filter(data=>data.type=="end")).length>0?true:false;
      chkSideJtrim = (cb_a_p_d_a.jtrim.filter(data => data.type == "side")).length > 0 ? true : false;
    }

    if(chkSideJtrim == true && totalSideWall != 0){
      isJtrimSide = true;
      checkSideWall = true
    }
    if(chkEndJtrim == true && totalEndWall != 0){
      isJtrim = true;
    }

    if (isJtrimSide == true) {
      if (chkSideJtrimNew.length > 0) {
        if (chkSideJtrimNew.filter(data => data.is_panel_jtrim != undefined).length > 0) {
          if ((this.props.params.p_c_p_l == true || this.props.params.p_c_p_r == true)) {

            if (checkSideWall == true) {
              if (chkSideJtrimNew.filter(data => data.is_cut_panel_jtrim == "included" || data.is_panel_jtrim == "included").length > 0) {
                SideJtrim_checkedDefault = true;
              }
            } else {
              if (chkSideJtrimNew.filter(data => data.is_cut_panel_jtrim == "included").length > 0) {
                SideJtrim_checkedDefault = true;
              }
            }
          } else {
            if (chkSideJtrimNew.filter(data => data.is_panel_jtrim == "included").length > 0) {
              SideJtrim_checkedDefault = true;
            }
          }
        }

      }
    }
    return (

      <>

        <div>
          <div className="form-group-md">
            <div className="radio-group">
              <Radio
                label="Open"
                value="openBackLeanWalls"
                name="openBackLeanWalls"
                checked={(this.props.const_var.setLeanWallOption.backLean == 'open') ? true : false}
                onClick={e => { this.props.toggleFullyOpenedCheckboxChange(e.target.value, 'openBackLeanWalls') }}
              />
            </div>
            <div className="radio-group">
              <Radio
                label="Fully Enclosed"
                value="closeBackLeanWalls"
                name="closeBackLeanWalls"
                checked={(this.props.const_var.setLeanWallOption.backLean == 'close') ? true : false}
                onClick={e => { this.props.toggleFullyEnclosedCheckboxChange(e.target.value, 'closeBackLeanWalls') }}
              />
            </div>
            <div className="radio-group">
              <Radio
                label="Custom"
                value="Custom"
                name="customBackLeanWalls"
                checked={(this.props.const_var.setLeanWallOption.backLean == 'partial') ? true : false}
                onClick={e => { this.props.toggleCustomCheckboxChange("backLeanto") }}
              />
            </div>
          </div>


        {/* drop-info */}
        {this.props.const_var.setLeanWallOption.backLean == 'partial' && 
            <div className="drop-info">
              <div className="drop-item-info">
                <div className="drop-text">
                  <div className="drop-label">Front</div>
                  {(this.props.const_var.loginSession == true) ?
                    <>
                      {((backLeanData != undefined && this.props.params.p_b_c_b_b_f != "Open")) ?
                        <div className='price-box'>
                          <EditPriceItem is_disabled={this.props.params.p_b_c_b_b_f == "Open" ? "true" : "false"} jsonObj={backLeanData.front_wall_price} jsonIsLeanto={'back'} jsonObjIndex={backLeanIndex} jsonObjKey="front_wall_price" />
                        </div> : null
                      }
                    </> : ""}
                  {(this.props.const_var.loginSession == false) ?
                    <>
                      {((this.props.const_var.hide_price_calculation != 1 && this.props.const_var.loginSession == false && backLeanData != undefined && backLeanData.front_wall_price !== undefined && backLeanData.front_wall_price !== 0)) ?
                        <div className='price-box-type-2'>
                          <CurrencyFormat value={backLeanData.front_wall_price} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                        </div> : null
                      }
                    </> : ""}
                </div>
                
                <div className={this.props.params.add_storage_check_back && this.props.params.backLeanStoragePosition === this.props.params.leanB_p_d - parseInt(this.props.params.add_storage_back) - (this.props.params.leanStyle.back !== "gable" && 0.2) ? "drop-action disabled" : "drop-action"}>
                  <Dropdown className="drop-default" onToggle={()=>toggleDropdown()}>
                    <Dropdown.Toggle as={DropDefaultToggle}>
                      <span className="text">{this.setName(this.props.params.p_b_c_b_b_f,this.props.backlentoSides)}</span>
                      <i className='icon icon-arrow-down-ico'></i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="drop-menu-default">
                      <ul className="drop-list-default">
                        {Object.entries(this.props.backlentoSides).map(([key, value], index) => {
                          return (
                            <li className="drop-list-item">
                              <div className='radio-group'>
                                <Radio
                                  onChange={e => { this.props.handleLeanToWallSelectonChangeValue(e, 'back_leanto_front', "back"); }}
                                  label={key}
                                  checked={this.props.params.p_b_c_b_b_f == value ? true : false}
                                  value={value}
                                />
                                {this.props.params.p_b_c_b_b_f == value && 
                                <>
                                  {(this.props.const_var.loginSession == true) ?
                                    <>
                                      {((backLeanData != undefined)) ?
                                        <div className='price-box'>
                                          <EditPriceItem is_disabled={this.props.params.p_b_c_b_b_f == "Open" ? "true" : "false"} jsonObj={backLeanData.front_wall_price} jsonIsLeanto={'back'} jsonObjIndex={backLeanIndex} jsonObjKey="front_wall_price" />
                                        </div> : null
                                      }
                                    </> : ""}
                                  {(this.props.const_var.loginSession == false) ?
                                    <>
                                      {((this.props.const_var.hide_price_calculation != 1 && this.props.const_var.loginSession == false && backLeanData != undefined && backLeanData.front_wall_price !== undefined && backLeanData.front_wall_price !== 0)) ?
                                        <div className='price-box-type-2'>
                                          <CurrencyFormat value={backLeanData.front_wall_price} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                        </div> : null
                                      }
                                    </> : ""}
                                  </>}
                              </div>
                            </li>
                          )
                        })
                        }
                      </ul>
                    </Dropdown.Menu>
                  </Dropdown>
                </div> 
              </div>
              {/* { (this.props.params.leanStyle.back !== "gable" || this.props.params.p_h === this.props.params.leanB_p_h && this.props.params.p_b_w == "Open" && this.props.params.p_w === this.props.params.leanB_p_w && this.props.params.p_r_p == this.props.params.b_l_t_r_pB) &&  */}
              { (this.props.params.leanStyle.back !== "gable" || (this.props.params.leanStyle.back === "gable" && this.props.params.p_b_w !== "Close")) && 
              <div className="drop-item-info">
                <div className="drop-text">
                    <div className="drop-label">Back</div>
                    {(this.props.const_var.loginSession == true) ?
                      <>
                        {((backLeanData != undefined && this.props.params.p_b_c_b_b_b != "Open")) ?
                          <div className='price-box'>
                            <EditPriceItem is_disabled={this.props.params.p_b_c_b_b_b == "Open" ? "true" : "false"} jsonObj={backLeanData.back_wall_price} jsonIsLeanto={'back'} jsonObjIndex={backLeanIndex} jsonObjKey="back_wall_price" />
                          </div> : null
                        }
                      </> : ""}
                    {(this.props.const_var.loginSession == false) ?
                      <>
                        {((this.props.const_var.hide_price_calculation != 1 && this.props.const_var.loginSession == false && backLeanData != undefined && backLeanData.back_wall_price !== undefined && backLeanData.back_wall_price !== 0)) ?
                          <div className='price-box-type-2'>
                            <CurrencyFormat value={backLeanData.back_wall_price} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                          </div> : null
                        }
                      </> : ""}
                  </div>
                  <div className={this.props.params.add_storage_check_back && this.props.params.backLeanStoragePosition <= 0 ? "drop-action disabled" : "drop-action"}>
                    <Dropdown className="drop-default" onToggle={()=>toggleDropdown()}>
                      <Dropdown.Toggle as={DropDefaultToggle}>
                        <span className="text">{this.setName(this.props.params.p_b_c_b_b_b,this.props.backlentoSides)}</span>
                        <i className='icon icon-arrow-down-ico'></i>
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="drop-menu-default">
                        <ul className="drop-list-default">
                          {Object.entries(this.props.backlentoSides).map(([key, value], index) => {
                            return (
                              <li className="drop-list-item">
                                <div className='radio-group'>
                                  <Radio
                                    onChange={e => { this.props.handleLeanToWallSelectonChangeValue(e, 'back_leanto_back', "back"); }}
                                    label={key}
                                    checked={this.props.params.p_b_c_b_b_b == value ? true : false}
                                    value={value}
                                  />
                                  {this.props.params.p_b_c_b_b_b == value && 
                                  <>
                                    {(this.props.const_var.loginSession == true) ?
                                      <>
                                        {((backLeanData != undefined)) ?
                                          <div className='price-box'>
                                            <EditPriceItem is_disabled={this.props.params.p_b_c_b_b_b == "Open" ? "true" : "false"} jsonObj={backLeanData.back_wall_price} jsonIsLeanto={'back'} jsonObjIndex={backLeanIndex} jsonObjKey="back_wall_price" />
                                          </div> : null
                                        }
                                      </> : ""}
                                    {(this.props.const_var.loginSession == false) ?
                                      <>
                                        {((this.props.const_var.hide_price_calculation != 1 && this.props.const_var.loginSession == false && backLeanData != undefined && backLeanData.back_wall_price !== undefined && backLeanData.back_wall_price !== 0)) ?
                                          <div className='price-box-type-2'>
                                            <CurrencyFormat value={backLeanData.back_wall_price} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                          </div> : null
                                        }
                                      </> : ""}
                                    </>}
                                </div>
                              </li>
                            )
                          })
                          }
                        </ul>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
              </div>}
              <div className="drop-item-info">
                <div className="drop-text">
                    <div className="drop-label">{this.props.params.leanStyle.back !== "gable" ? "Side" : "Left"}</div>
                    {(this.props.const_var.loginSession == true) ?
                      <>
                        {((backLeanData != undefined && this.props.params.p_b_c_b_b_l != "Open")) ?
                          <div className='price-box'>
                            <EditPriceItem is_disabled={this.props.params.p_b_c_b_b_l == "Open" ? "true" : "false"} jsonObj={backLeanData.side_wall_price} jsonIsLeanto={'back'} jsonObjIndex={backLeanIndex} jsonObjKey="side_wall_price" />
                          </div> : null
                        }
                      </> : ""}
                    {(this.props.const_var.loginSession == false) ?
                      <>
                        {((this.props.const_var.hide_price_calculation != 1 && this.props.const_var.loginSession == false && backLeanData != undefined && backLeanData.side_wall_price !== undefined && backLeanData.side_wall_price !== 0)) ?
                          <div className='price-box-type-2'>
                            <CurrencyFormat value={backLeanData.side_wall_price} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                          </div> : null
                        }
                      </> : ""}
                  </div>
                  <div className="drop-action">
                    <Dropdown className="drop-default" onToggle={()=>toggleDropdown()}>
                      <Dropdown.Toggle as={DropDefaultToggle}>
                        <span className="text">{this.setName(this.props.params.p_b_c_b_b_l,this.props.backlentoEnds)}</span>
                        <i className='icon icon-arrow-down-ico'></i>
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="drop-menu-default">
                        <ul className="drop-list-default">
                          {Object.entries(this.props.backlentoEnds).map(([key, value], index) => {
                            return (
                              <li className="drop-list-item">
                                <div className='radio-group'>
                                  <Radio
                                    onChange={e => { this.props.handleLeanToWallSelectonChangeValue(e, 'back_leanto_left', "back"); }}
                                    label={key}
                                    checked={this.props.params.p_b_c_b_b_l == value ? true : false}
                                    value={value}
                                  />
                                  {this.props.params.p_b_c_b_b_l == value &&
                                  <>
                                    {(this.props.const_var.loginSession == true) ?
                                      <>
                                        {((backLeanData != undefined)) ?
                                          <div className='price-box'>
                                            <EditPriceItem is_disabled={this.props.params.p_b_c_b_b_l == "Open" ? "true" : "false"} jsonObj={backLeanData.side_wall_price} jsonIsLeanto={'back'} jsonObjIndex={backLeanIndex} jsonObjKey="side_wall_price" />
                                          </div> : null
                                        }
                                      </> : ""}
                                    {(this.props.const_var.loginSession == false) ?
                                      <>
                                        {((this.props.const_var.hide_price_calculation != 1 && this.props.const_var.loginSession == false && backLeanData != undefined && backLeanData.side_wall_price !== undefined && backLeanData.side_wall_price !== 0)) ?
                                          <div className='price-box-type-2'>
                                            <CurrencyFormat value={backLeanData.side_wall_price} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                          </div> : null
                                        }
                                      </> : ""}
                                    </>}
                                </div>
                              </li>
                            )
                          })
                          }
                        </ul>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
              </div>
              {this.props.params.leanStyle.back == "gable"
                ?
                <div className="drop-item-info">
                <div className="drop-text">
                    <div className="drop-label">Right</div>
                    {(this.props.const_var.loginSession == true) ?
                      <>
                        {((backLeanData != undefined && this.props.params.p_b_c_b_b_r != "Open")) ?
                          <div className='price-box'>
                            <EditPriceItem is_disabled={this.props.params.p_b_c_b_b_r == "Open" ? "true" : "false"} jsonObj={backLeanData.right_wall_price} jsonIsLeanto={'back'} jsonObjIndex={backLeanIndex} jsonObjKey="right_wall_price" />
                          </div> : null
                        }
                      </> : ""}
                    {(this.props.const_var.loginSession == false) ?
                      <>
                        {((this.props.const_var.hide_price_calculation != 1 && this.props.const_var.loginSession == false && backLeanData != undefined && backLeanData.right_wall_price !== undefined && backLeanData.right_wall_price !== 0)) ?
                          <div className='price-box-type-2'>
                            <CurrencyFormat value={backLeanData.right_wall_price} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                          </div> : null
                        }
                      </> : ""}
                  </div>
                  <div className="drop-action">
                    <Dropdown className="drop-default" onToggle={()=>toggleDropdown()}>
                      <Dropdown.Toggle as={DropDefaultToggle}>
                        <span className="text">{this.setName(this.props.params.p_b_c_b_b_r,this.props.backlentoEnds)}</span>
                        <i className='icon icon-arrow-down-ico'></i>
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="drop-menu-default">
                        <ul className="drop-list-default">
                          {Object.entries(this.props.backlentoEnds).map(([key, value], index) => {
                            return (
                              <li className="drop-list-item">
                                <div className='radio-group'>
                                  <Radio
                                    onChange={e => { this.props.handleLeanToWallSelectonChangeValue(e, 'back_leanto_right', "back"); }}
                                    label={key}
                                    checked={this.props.params.p_b_c_b_b_r == value ? true : false}
                                    value={value}
                                  />
                                  {this.props.params.p_b_c_b_b_r == value &&
                                  <>
                                    {(this.props.const_var.loginSession == true) ?
                                      <>
                                        {((backLeanData != undefined)) ?
                                          <div className='price-box'>
                                            <EditPriceItem is_disabled={this.props.params.p_b_c_b_b_r == "Open" ? "true" : "false"} jsonObj={backLeanData.right_wall_price} jsonIsLeanto={'back'} jsonObjIndex={backLeanIndex} jsonObjKey="right_wall_price" />
                                          </div> : null
                                        }
                                      </> : ""}
                                    {(this.props.const_var.loginSession == false) ?
                                      <>
                                        {((this.props.const_var.hide_price_calculation != 1 && this.props.const_var.loginSession == false && backLeanData != undefined && backLeanData.right_wall_price !== undefined && backLeanData.right_wall_price !== 0)) ?
                                          <div className='price-box-type-2'>
                                            <CurrencyFormat value={backLeanData.right_wall_price} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                          </div> : null
                                        }
                                      </> : ""}
                                    </>}
                                </div>
                              </li>
                            )
                          })
                          }
                        </ul>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
                :
                null
              }    
            </div>
        }
        <div className="form-group">
        {((cb_a_p_d_a.jtrim) && cb_a_p_d_a.jtrim.length > 0 && (isJtrim == true || isJtrimSide == true)) &&
          <label class="control-label">J-Trim</label>}
          {((cb_a_p_d_a.jtrim) && cb_a_p_d_a.jtrim.length > 0 && isJtrim == true && (this.props.params.p_b_c_b_b_f != "Half End" || this.props.params.p_b_c_b_b_b != "Half End")) ?
            <div className="row">
              <div className={(this.props.const_var.loginSession == true && EndJtrim_checkedDefault != true) ? "col" : "col"}>
                <div className="check-group">
                  <Checkbox
                    label={EndJtrim_checkedDefault == true ? "End J Trim (Included)" : "End J Trim"}
                    name="jtrim"
                    disabled={EndJtrim_checkedDefault}
                    checked={this.props.params.p_j_t_end}
                    onChange={e =>
                      this.props.extraItemsAction(e.target.value, 'end_jtrim')}
                  />
                  {(this.props.const_var.loginSession == true && EndJtrim_checkedDefault != true && this.props.params.p_j_t_end == true) ?
                    <>
                      {((this.props.const_var.post_data.building != undefined)) ?
                        <div className='price-box'>
                          <EditPriceItem updatedPriceDataObj={const_var.lNTBuildingData["updatePriceDataElements"]["centerBuilding"]} is_disabled={(this.props.params.p_j_t_end == true) ? "false" : "true"} jsonObj={'extraitems'} jsonObjValue={this.props.params.p_j_t_end} jsonObjKey="End Jtrim" />
                        </div> : null
                      }
                    </> : <EndJTrimPrice />}
                </div>
              </div>
            </div> : null
          }

          {((cb_a_p_d_a.jtrim) && cb_a_p_d_a.jtrim.length > 0 && isJtrimSide == true) ?
            <div className="row">
              <div className={(this.props.const_var.loginSession == true && SideJtrim_checkedDefault != true) ? "col" : "col"}>
                <div className="check-group">
                  <Checkbox
                    label={SideJtrim_checkedDefault == true ? "Side J Trim (Included)" : "Side J Trim"}
                    name="jtrim"
                    disabled={SideJtrim_checkedDefault}
                    checked={this.props.params.p_j_t}
                    onChange={e => this.props.extraItemsAction(e.target.value, 'jtrim')}
                  />
                {(this.props.const_var.loginSession == true && SideJtrim_checkedDefault != true && this.props.params.p_j_t == true) ?
                  <>
                    {((this.props.const_var.post_data.building != undefined)) ?
                      <div className='price-box  '>
                        <EditPriceItem updatedPriceDataObj={const_var.lNTBuildingData["updatePriceDataElements"]["centerBuilding"]} is_disabled={(this.props.params.p_j_t == true) ? "false" : "true"} jsonObj={'extraitems'} jsonObjValue={this.props.params.p_j_t} jsonObjKey="Jtrim" />
                      </div> : null
                    }
                  </> : <SideJTrimPrice />}
                </div>
              </div>
            </div> : null
          }
        </div>


        <div className={Object.keys(this.props.const_var.BackLeandrop_arr).length>0 ? "form-group" : "form-group disabled"}>
          <div className='control-label'>Storage</div>
          <div className="row">
            <div className={`col ${this.props.const_var.is_loader==true ? ' disabled' : ''}`}>    
            {(const_var.DistanceArr.length > 0 && const_var.DistanceArr[params.p_b_t][params.p_r_s] != undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s] == 5 ? params.leanB_p_d >= 10 : params.leanB_p_d >= 10) &&          
              <div className="check-group">
                <Checkbox
                  label={this.props.const_var.post_data.building!=undefined && backLeanData != undefined && backLeanData.utility_position!=undefined && backLeanData.utility_position!=0?"Storage ("+ Math.round(backLeanData.utility_position)+"' from Back)":"Add Storage"}
                  value={this.props.params.add_storage_check_back}
                  className=''
                  checked={this.props.params.add_storage_check_back}
                  disabled={(Object.keys(this.props.const_var.BackLeandrop_arr).length == 0) ? true : false}
                  onChange={(e) => { this.storageLength(e) }}
                />
                {(this.props.const_var.loginSession == true) ?
                <>
                  {((this.props.const_var.post_data.building != undefined && backLeanData != undefined && backLeanData.utility_price != undefined)) ?                  
                    <div className='price-box'>
                      <EditPriceItem jsonObj={backLeanData.utility_price} jsonIsLeanto={'back'} jsonObjIndex={backLeanIndex} jsonObjKey="utility_price" />
                    </div> : null
                  }
                </> : ""}
                {(this.props.const_var.loginSession == false) ?
                <>
                  {((this.props.const_var.hide_price_calculation != 1 && this.props.const_var.loginSession == false && backLeanData != undefined && backLeanData.utility_price !== undefined && backLeanData.utility_price !== 0)) ?                  
                    <div className='price-box-type-2'>
                      <CurrencyFormat value={backLeanData.utility_price} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                    </div> : null
                  }
                </> : ""}
              </div>
            }
            </div>

            <div className="col-auto text-right">
              {(this.props.params.add_storage_check_back == true) ?
                <Dropdown className="drop-default" onToggle={()=>toggleDropdown()}>
                  <Dropdown.Toggle as={DropDefaultToggle}>
                    <span className="text">{this.props.params.add_storage_back} Feet</span>
                    <i className='icon icon-arrow-down-ico'></i>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="drop-menu-default">
                    <ul className="drop-list-default">
                      {Object.entries(this.props.const_var.BackLeandrop_arr).map(([key, value]) => {
                        return (
                          <li className="drop-list-item">
                            <div className='radio-group'>
                              <Radio
                                onChange={(e) => { this.props.handleUtilityLenghtSelectonChangeValue(e, "back"); this.props.getPricingDataForLeanto(e.target.value, 'addBackLean', '', false); }}
                                checked={this.props.params.add_storage_back == value ? true : false}
                                label={key}
                                value={value}
                              />
                              { this.props.params.add_storage_back == value &&
                              <>
                             
                              {(this.props.const_var.loginSession == true) ?
                              <>
                                {((this.props.const_var.post_data.building != undefined && backLeanData != undefined && backLeanData.utility_price != undefined)) ?                  
                                  <div className='price-box'>
                                    <EditPriceItem jsonObj={backLeanData.utility_price} jsonIsLeanto={'back'} jsonObjIndex={backLeanIndex} jsonObjKey="utility_price" />
                                  </div> : null
                                }
                              </> : ""}
                              {(this.props.const_var.loginSession == false) ?
                              <>
                                {((this.props.const_var.hide_price_calculation != 1 && this.props.const_var.loginSession == false && backLeanData != undefined && backLeanData.utility_price !== undefined && backLeanData.utility_price !== 0)) ?                  
                                  <div className='price-box-type-2'>
                                    <CurrencyFormat value={backLeanData.utility_price} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                  </div> : null
                                }
                              </> : ""}
                              </>}
                            </div>
                          </li>
                        )
                      })}
                    </ul>
                  </Dropdown.Menu>
                </Dropdown>
                
                : null
              }
            </div>
          </div>
        </div>


          {/* {(!this.props.const_var.isInsulaltionForOldQuotes && const_var.insulationArrayForLeantoBack.length > 0) &&
            <Insulation
              type="backLean"
              insulation={const_var.insulationArrayForLeantoBack}
              insulation_price={backLeanData?.insulation_price}
              leanIndex={backLeanIndex}
            />
          } */}
        </div>

      </>
    );
  }
}
const mapStateToProps = (state) => {
  return { ...state.reducer, ...state.priceUpdateReducer }
}
export default connect(
  mapStateToProps,
  actionCreator
)(BackLeantoWalls);
